import { useEffect } from "react";

import { mixpanelTrackEvent } from "services/mixpanel";
import { EVENT_TYPES } from "constants/mixpanel";

import EmployeesSearchBarV2 from "../EmployeesSearchBarV2";

const SearchEmployees = () => {
  useEffect(() => {
    mixpanelTrackEvent(EVENT_TYPES.SEARCH_PAGE_NAVIGATION);
  }, []);

  return (
    <div className="w-full h-full flex-col gap-4 p-14 items-center flex bg-default-background container max-w-none">
      <EmployeesSearchBarV2 />
    </div>
  );
};

export default SearchEmployees;
